import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { InvestorsTable, TableBoxContainer } from '@/components';
import { Flex, Col } from '@/ui';
import {
  INVESTOR_STATUS_DESCRIPTION,
  INVESTOR_STATUS_TABS,
  IS_IN_REVIEW_TAB_VALUE,
  LEGAL_STATUS_DESCRIPTION,
  STATUS_TAB_VALUE
} from '@/utils/static';
import { useTranslation } from 'react-i18next';
import { Input, Select } from 'antd';

const { Search } = Input;
const TAB_DESCR = {
  PERSONAL: INVESTOR_STATUS_DESCRIPTION,
  COMPANY: LEGAL_STATUS_DESCRIPTION
};
export const InvestorsTableBox = ({
  investors,
  updateSearchParams,
  INVESTORS_ON_PAGE,
  selectedTab
}) => {
  const { t } = useTranslation();
  const { type } = useParams();
  const [search, setSearch] = useState('');
  const [selectedPage, setSelectedPage] = useState(0);
  const [accountType, setAccountType] = useState(0);
  const accountTypes = [
    {
      label: t('All types'),
      value: 0
    },
    {
      label: t('Investors'),
      value: 1
    },
    {
      label: t('Agents'),
      value: 2
    },
    {
      label: t('Assistants'),
      value: 3
    }
  ];

  useEffect(() => {
    if (search) setSearch('');
    if (selectedPage) setSelectedPage(0);
    refetchInvestors({ searchValue: '' });
  }, [type]);

  const refetchInvestors = ({
    searchValue = search,
    typeValue = type,
    skip = 0,
    isInvestor = accountType === 1,
    isAgent = accountType === 2,
    isRecommender = accountType === 3
  }) => {
    const searchParams = {
      search: searchValue,
      accountStatus: STATUS_TAB_VALUE[selectedTab],
      inReview: IS_IN_REVIEW_TAB_VALUE[selectedTab],
      account: typeValue,
      skip: skip
    };
    if (isAgent) searchParams.isAgent = true;
    if (isRecommender) searchParams.isRecommender = true;
    if (isInvestor) searchParams.isInvestor = true;

    updateSearchParams(searchParams);
  };

  //onUpdateSelectedTab
  useEffect(() => {
    onUpdateSearch();
  }, [selectedTab]);

  //onUpdateSearch
  const onUpdateSearch = () => {
    refetchInvestors({});
    setSelectedPage(0);
  };
  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      onUpdateSearch();
    }
  };

  //onUpdateAccountType
  const onUpdateAccountType = (type) => {
    refetchInvestors({ isInvestor: type === 1, isAgent: type === 2, isRecommender: type === 3 });
    setAccountType(type);
    setSelectedPage(0);
  };

  //onUpdatePage
  const onUpdatePage = (page) => {
    refetchInvestors({ skip: page * INVESTORS_ON_PAGE });
    setSelectedPage(page);
  };

  if (investors) {
    const descriptions = TAB_DESCR[type] || INVESTOR_STATUS_TABS;
    return (
      <TableBoxContainer
        title={t(descriptions[selectedTab])}
        table={
          <InvestorsTable
            data={investors?.investors}
            investorStatusType={selectedTab}
            total={investors.count}
            onChange={onUpdatePage}
            refetchInvestors={() => {
              refetchInvestors({
                skip:
                  (investors.count - 1) % INVESTORS_ON_PAGE === 0 && selectedPage !== 0
                    ? selectedPage - 1 * INVESTORS_ON_PAGE
                    : selectedPage * INVESTORS_ON_PAGE
              });
              if ((investors.count - 1) % INVESTORS_ON_PAGE === 0 && selectedPage !== 0) {
                setSelectedPage(selectedPage - 1);
              }
            }}
          />
        }
        total={investors.count}
        current={selectedPage}
        onChange={(item) => onUpdatePage(item)}
        innerBoxProps={{ $paddingBottom: 16 }}
      >
        <Flex $margin={-8} $marginY={16} gap={16} wrap>
          <Col $auto $minWidth={'150px'}>
            <Search
              value={search}
              onChange={(value) => setSearch(value.currentTarget.value)}
              onBlur={onUpdateSearch}
              onSearch={(value) => onUpdateSearch()}
              onKeyDown={handleSearchKeyDown}
              placeholder={t('Search')}
            />
          </Col>

          <Col $auto>
            <Select defaultValue={0} options={accountTypes} onChange={onUpdateAccountType} />
          </Col>
        </Flex>
      </TableBoxContainer>
    );
  }

  return null;
};
